import { useEffect, useState, useRef } from "react";
import axios from "axios";
import "../../.csscode/PopUpModal.css";
import Select from "react-select";
import { toast } from "sonner";
import SucessModal from "../successModal/SuccessModal";
import {
  Box,
  Tabs,
  Tab,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CustomLoader from "../static/CustomLoader";
import { uploadDocument, viewDocument } from "../utiles/DocumentService";
import { envCode, MAX_FILE_SIZE, ALLOWED_TYPES } from "../Constant";

const Auditee = ({
  selectedId,
  mode,
  onHide,
  setRefresh,
  divData,
  userData,
  employeeTypeOptions,
  licenseRenewalData,
  hazardCategoryData,
  sectionData,
  sectorData,
  workingData,
  ownshirpData,
}) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const orgCode = localStorage.getItem("custCode");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [id, setId] = useState("");
  const [code, setCode] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");

  const [divcode, setDivcode] = useState(null);
  const [licencenumber, setLicencenumber] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [primaryphone, setPrimaryphone] = useState("");
  const [email, setEmail] = useState("");
  const [addressline, setAddressline] = useState("");
  const [city, setCity] = useState("");
  const [dist, setDist] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [pincode, setPincode] = useState("");
  const [latd, setLatd] = useState("");
  const [longt, setLongt] = useState("");
  const [amendment, setAmendment] = useState("");
  const [user, setUser] = useState(0);

  const [documents, setDocuments] = useState([
    {
      file: null,
      fileName: "",
      fileType: "",
      filePurpose: "",
      previewUrl: "",
    },
  ]);

  const fileInputRefs = useRef([]);

  const [formData, setFormData] = useState({});
  const requiredFields = [
    "natureOfManufacturing",
    "horsePower",
    "kilowatt",
    "fees",
    "licenseRenewalStatus",
    "licenseStrength",
    "hazardCategory",
    "coveredUnderSection",
    "sector",
    "workingStatus",
    "ownership",
  ];

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const [occupierData, setOccupierData] = useState([
    { firstName: "", lastName: "", contactNumber: "", email: "" },
  ]);

  const [directorData, setDirectorData] = useState([
    { firstName: "", lastName: "", contactNumber: "", email: "" },
  ]);

  const [employeeData, setEmployeeData] = useState([
    { employeeType: "", adultMale: "", adultFemale: "" },
  ]);

  const handleEmployeeChange = (index, field, value) => {
    const updated = [...employeeData];
    updated[index][field] = value;
    setEmployeeData(updated);
  };

  const handleDirectorChange = (index, field, value) => {
    const updated = [...directorData];
    updated[index][field] = value;
    setDirectorData(updated);
  };

  const removeDirector = (index) => {
    const updated = [...directorData];
    updated.splice(index, 1);
    setDirectorData(updated);
  };

  const removeEmployee = (index) => {
    const updated = [...employeeData];
    updated.splice(index, 1);
    setEmployeeData(updated);
  };

  const removeDocumentRow = (index) => {
    const updated = [...documents];
    updated.splice(index, 1);
    setDocuments(updated);
  };

  const addDocumentRow = () => {
    setDocuments((prev) => [
      ...prev,
      {
        file: null,
        fileName: "",
        fileType: "",
        filePurpose: "",
        previewUrl: "",
      },
    ]);
  };

  const handleFileUpload = async (index, event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!ALLOWED_TYPES.includes(file.type)) {
      toast.error("Only Images (JPG, PNG) and PDFs are allowed.");
      if (fileInputRefs.current[index]) {
        fileInputRefs.current[index].value = "";
      }
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      toast.error("File size must be less than 5 MB.");
      if (fileInputRefs.current[index]) {
        fileInputRefs.current[index].value = "";
      }
      return;
    }
    setLoading(true);
    try {
      const previewUrl = URL.createObjectURL(file);
      const updated = [...documents];
      updated[index] = {
        file,
        fileName: file.name,
        fileType: file.type,
        previewUrl,
      };

      setDocuments(updated);
    } catch (error) {
      console.error(error);
      toast.error("Upload failed");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handlePurposeChange = (index, value) => {
    const updated = [...documents];
    updated[index].filePurpose = value;
    setDocuments(updated);
  };
  const fetchPreviewFile = async (logoName, orgCode, factoryCode) => {
    try {
      const folderPath = `${orgCode}/auditee${factoryCode}`;

      const response = await viewDocument({
        projectCode: "Ptw",
        envCode,
        folderPath,
        fileName: logoName,
      });

      if (response.cd === 1) {
        return "";
      }

      const base64Data = response;

      const mimeType = logoName.toLowerCase().endsWith(".pdf")
        ? "application/pdf"
        : "image/*";

      const binaryString = atob(base64Data);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);

      for (let i = 0; i < len; i++) bytes[i] = binaryString.charCodeAt(i);

      const blob = new Blob([bytes], { type: mimeType });
      return URL.createObjectURL(blob);
    } catch (e) {
      console.error("Preview fetch error:", e);
    }

    return "";
  };

  const addEmployee = () => {
    setEmployeeData((prev) => [
      ...prev,
      { employeeType: "", adultMale: "", adultFemale: "" },
    ]);
  };

  const addDirector = () => {
    setDirectorData((prev) => [
      ...prev,
      { firstName: "", lastName: "", contactNumber: "", email: "" },
    ]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    onHide();
    setRefresh(true);
  };

  useEffect(() => {
    if (mode === "U") {
      const fetchAuditeesData = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            `${apiUrl}auditee/id/${selectedId}`,
            { headers },
          );
          const data = response.data;
          if (data.cd === 1) {
            toast.info(data.description);
          } else {
            const industry = JSON.parse(response.data.industry);
            const occupier = response.data.occupier;
            const directores = response.data.manager;
            const employee = response.data.employee;
            setId(data.id);
            setCode(data.code);
            setDivcode(data.divcode);
            setLicencenumber(data.licencenumber);
            setName(data.name);
            setDescription(data.description);
            setPrimaryphone(data.primaryphone);
            setEmail(data.email);
            setCity(data.city);
            setPincode(data.pincode);
            setDist(data.dist);
            setState(data.state);
            setCountry(data.country);
            setLatd(data.latd);
            setLongt(data.longt);
            setAmendment(data.amendment);
            setUser(data.user);
            setFormData((prev) => ({
              ...prev,
              divisionCode: industry.divisionCode,
              districtCode: industry.districtCode,
              talukCode: industry.talukCode,
              factoryRegDate: industry.factoryRegDate,
              nicCode: industry.nicCode,
              natureOfManufacturing: industry.natureOfManufacturing,
              horsePower: industry.horsePower,
              kilowatt: industry.kilowatt,
              fees: industry.fees,
              licenseRenewalStatus: industry.licenseRenewalStatus,
              licenseStrength: industry.licenseStrength,
              hazardCategory: industry.hazardCategory,
              coveredUnderSection: industry.coveredUnderSection,
              sector: industry.sector,
              workingStatus: industry.workingStatus,
              ownership: industry.ownership,
              occupierEmail: industry.occupierEmail,
              occupierPhone: industry.occupierPhone,
              occupierAddress: industry.occupierAddress,
              managerEmail: industry.managerEmail,
              managerPhone: industry.managerPhone,
              managerAddress: industry.managerAddress,
              managername: industry.managername,
              occupiername: industry.occupiername,
            }));

            const parsedOccupier = JSON.parse(occupier);
            if (Array.isArray(parsedOccupier)) {
              setOccupierData(parsedOccupier);
            }

            const parsedDirectors = JSON.parse(directores);
            if (Array.isArray(parsedDirectors)) {
              setDirectorData(parsedDirectors);
            }

            const parsedEmployee = JSON.parse(employee);
            if (Array.isArray(parsedEmployee)) {
              setEmployeeData(parsedEmployee);
            }
          }
          fetchExistingDocuments(data.code, orgCode);
        } catch (error) {
          toast.error("Failed to fetch details.");
        } finally {
          setLoading(false);
        }
      };

      fetchAuditeesData();
    }
  }, [mode]);

  function clearFields() {
    setErrors({});
    setId("");
    setCode("");
    setDivcode(null);
    setLicencenumber("");
    setName("");
    setDescription("");
    setPrimaryphone("");
    setEmail("");
    setAddressline("");
    setCity("");
    setDist("");
    setState("");
    setCountry("");
    setPincode("");
    setLatd("");
    setLongt("");
    setUser(0);
    setFormData({});
    setOccupierData([
      { firstName: "", lastName: "", contactNumber: "", email: "" },
    ]);
    setDirectorData([
      { firstName: "", lastName: "", contactNumber: "", email: "" },
    ]);
    setEmployeeData([{ employeeType: "", adultMale: "", adultFemale: "" }]);
  }

  const handleDatabseDocuments = async (updateDoc, factoryCode) => {
    setLoading(true);

    const headers = {
      Authorization: `Bearer ${dbTokenData}`,
      "Content-Type": "application/json",
      dbMaster: "",
    };

    try {
      const docList = updateDoc.map((doc) => ({
        auditeecode: factoryCode,
        type: doc.fileType,
        name: doc.fileName,
        purpose: doc.filePurpose,
      }));

      if (docList.length === 0) {
        toast.warning("No documents to save");
        return;
      }

      const response = await axios.post(`${apiUrl}auditeedoc`, docList, {
        headers,
      });

      if (response.data.cd === 1) {
        toast.error(response.data.description || "Document save failed");
      } else {
        toast.success(
          response.data.description || "Documents saved successfully",
        );
      }
    } catch (error) {
      toast.error("Something went wrong while uploading documents.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitDocuments = async (code) => {
    setLoading(true);

    try {
      const updatedDocuments = [...documents];

      for (let index = 0; index < documents.length; index++) {
        const doc = documents[index];

        if (!doc || !doc.file) continue;

        const file = doc.file;
        const folderPath = `${orgCode}/auditee${code}`;

        const uploadRes = await uploadDocument({
          file: file,
          projectCode: "Ptw",
          envCode,
          folderPath,
        });

        if (uploadRes?.cd === 1) {
          toast.error(uploadRes.description);
          setLoading(false);
          return;
        }

        updatedDocuments[index] = {
          ...doc,
          fileName: uploadRes,
          fileType: file.type,
        };
      }

      setDocuments(updatedDocuments);

      await handleDatabseDocuments(updatedDocuments, code);

      toast.success("All documents uploaded and saved successfully!");
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong while uploading documents.");
    } finally {
      setLoading(false);
    }
  };

  const fetchExistingDocuments = async (code, orgCode) => {
    setLoading(true);

    try {
      const res = await axios.get(`${apiUrl}auditeedoc/${code}`, { headers });

      if (res.data.cd === 1) {
        toast.error(res.data.description || "No documents found");
        return;
      }
      if (!res.data || res.data.length === 0) {
        setDocuments([
          {
            file: null,
            fileName: "",
            fileType: "",
            filePurpose: "",
            previewUrl: "",
          },
        ]);
        return;
      }
      const rows = res.data || [];

      const mappedDocs = await Promise.all(
        rows.map(async (item) => {
          const previewUrl = await fetchPreviewFile(item.name, orgCode, code);

          return {
            file: null,
            fileName: item.name,
            fileType: item.type,
            filePurpose: item.purpose,
            previewUrl: previewUrl,
          };
        }),
      );

      setDocuments(mappedDocs);
    } catch (err) {
      toast.error("Failed to load existing documents");
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async () => {
    const payLoad = {
      divcode: divcode,
      licencenumber: licencenumber,
      name: name,
      description: description,
      primaryphone: primaryphone,
      email: email,
      addressline: addressline,
      city: city,
      dist: dist,
      state: state,
      country: country,
      pincode: pincode,
      latd: latd,
      longt: longt,
      industry: JSON.stringify(formData),
      occupier: JSON.stringify(occupierData),
      manager: JSON.stringify(directorData),
      employee: JSON.stringify(employeeData),
      amendment: amendment,
      user: user,
    };

    try {
      const response = await axios.post(`${apiUrl}auditee`, payLoad, {
        headers,
      });
      if (response.data.cd === 1) {
        setSucessMessage(response.data.description);
        setTitle("⚠️ Failed");
      } else {
        setSucessMessage("Auditee saved successfully");
        setTitle("✔️ Success");
        setShowSucessModal(true);
        const hasDocuments = documents.some(
          (doc) => doc.fileType && doc.fileType.trim() !== "",
        );

        if (hasDocuments) {
          await handleSubmitDocuments(response.data.code);
        }
      }
    } catch (error) {
      toast.error("Something went wrong while adding data.");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    const payLoad = {
      id: id,
      code: code,
      divcode: divcode,
      licencenumber: licencenumber,
      name: name,
      description: description,
      primaryphone: primaryphone,
      email: email,
      addressline: addressline,
      city: city,
      dist: dist,
      state: state,
      country: country,
      pincode: pincode,
      latd: latd,
      longt: longt,
      industry: JSON.stringify(formData),
      occupier: JSON.stringify(occupierData),
      manager: JSON.stringify(directorData),
      employee: JSON.stringify(employeeData),
      amendment: amendment,
      user: user,
    };

    try {
      const response = await axios.put(
        `${apiUrl}auditee/${selectedId}`,
        payLoad,
        { headers },
      );
      if (response.data.cd === 1) {
        setSucessMessage(response.data.description);
        setTitle("⚠️ Failed");
      } else {
        setSucessMessage(response.data.description);
        setTitle("✔️ Success");
        const hasDocuments = documents.some(
          (doc) => doc.fileType && doc.fileType.trim() !== "",
        );

        if (hasDocuments) {
          await handleSubmitDocuments(code);
        }
      }
      setShowSucessModal(true);
    } catch (error) {
      toast.error("Something went wrong while updating data.");
    } finally {
      setLoading(false);
    }
  };

  const handlesubmit = async () => {
    setLoading(true);

    const firstTabValid = validateFirstTabForm();

    if (!firstTabValid) {
      setActiveTab(0);
      setLoading(false);
      toast.warning("Please fill all requied filed...");
      return;
    }

    if (mode === "A") {
      await handleAdd();
    } else {
      await handleUpdate();
    }
  };

  const validateFirstTabForm = () => {
    let newErrors = {};
    if (!user) newErrors.user = "Employee/User is required.";
    if (!divcode) newErrors.divcode = "Division  is required.";
    if (!licencenumber.trim())
      newErrors.licencenumber = "Licence number is required.";
    if (!name.trim()) newErrors.name = "Name is required.";
    if (!pincode) newErrors.pincode = "Pincode is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchPincodeDetails = async (enteredPincode) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://api.postalpincode.in/pincode/${enteredPincode}`,
      );
      if (
        response.data &&
        response.data.length > 0 &&
        response.data[0].Status === "Success"
      ) {
        const postOffice = response.data[0].PostOffice[0];
        setCity(postOffice.Block || "");
        setDist(postOffice.District || "");
        setState(postOffice.State || "");
        setCountry(postOffice.Country || "");
        setLoading(false);
      } else {
        toast.error("Invalid pincode or details not found.");
        setCity("");
        setDist("");
        setState("");
        setCountry("");
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to fetch location from pincode.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const inputSx = {
    width: "100%",
  };

  const selectClassName = "select";

  const fieldLabelSx = {
    display: "block",
    marginBottom: "6px",
    fontSize: "12.5px",
    lineHeight: 1.2,
    fontWeight: 600,
    color: "#33485C",
  };

  const tabSx = {
    minHeight: 46,
    backgroundColor: "#F5F8FB",
    borderRadius: "8px 8px 0 0",
    borderBottom: "1px solid #DCE4EC",
    "& .MuiTabs-flexContainer": {
      gap: 0.25,
    },
    "& .MuiTab-root": {
      minHeight: 46,
      px: { xs: 1.25, sm: 2 },
      color: "#667584",
      fontWeight: 600,
      fontSize: { xs: "12px", sm: "13px" },
      textTransform: "none",
      whiteSpace: "nowrap",
    },
    "& .MuiTab-root:hover": {
      color: "#123B5D",
      backgroundColor: "#EEF4F9",
    },
    "& .Mui-selected": {
      color: "#123B5D !important",
      fontWeight: 700,
    },
    "& .MuiTabs-indicator": {
      height: 3,
      borderRadius: "3px 3px 0 0",
      backgroundColor: "#123B5D",
    },
  };

  const renderError = (message) =>
    message ? <span className="error-message">{message}</span> : null;

  const renderInput = ({
    label,
    name,
    value,
    onChange,
    type = "text",
    required = false,
    error,
    readOnly = false,
    disabled = false,
    placeholder = "",
    maxLength,
    min,
  }) => (
    <div className="form-group">
      <label style={fieldLabelSx}>
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <input
        type={type}
        name={name}
        value={value ?? ""}
        onChange={onChange}
        className={`form-control ${error ? "is-invalid" : ""}`}
        required={required}
        readOnly={readOnly}
        disabled={disabled}
        placeholder={placeholder}
        maxLength={maxLength}
        min={min}
      />
      {renderError(error)}
    </div>
  );

  const renderSelect = ({
    label,
    options,
    value,
    onChange,
    placeholder,
    required = false,
    error,
  }) => (
    <div className="form-group">
      <label style={fieldLabelSx}>
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <Select
        isClearable
        options={options || []}
        value={
          value === null || value === undefined || value === ""
            ? null
            : (options || []).find((opt) => opt.value === value) || null
        }
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        classNamePrefix={selectClassName}
      />
      {renderError(error)}
    </div>
  );

  const renderBasicTab = () => (
    <Box
      sx={{
        pt: 1.5,
        "& .form-group": {
          marginBottom: 0,
        },
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: "repeat(3, minmax(0, 1fr))",
          },
          columnGap: { xs: 1.5, md: 2 },
          rowGap: 1.5,
        }}
      >
        {renderSelect({
          label: "Employee/User",
          options: userData,
          value: user,
          onChange: (selected) => setUser(selected?.value),
          placeholder: "Select User",
          required: true,
          error: errors.user,
        })}

        {renderSelect({
          label: "Division",
          options: divData,
          value: divcode,
          onChange: (selected) => setDivcode(selected?.value),
          placeholder: "Select Division",
          required: true,
          error: errors.divcode,
        })}

        {renderInput({
          label: "Licence Number",
          name: "licencenumber",
          value: licencenumber,
          onChange: (e) => setLicencenumber(e.target.value),
          required: true,
          error: errors.licencenumber,
          placeholder: "Enter Licence Number",
        })}

        {renderInput({
          label: "Name",
          name: "name",
          value: name,
          onChange: (e) => setName(e.target.value),
          required: true,
          error: errors.name,
          placeholder: "Enter Name",
        })}

        {renderInput({
          label: "Primary Phone",
          name: "primaryphone",
          value: primaryphone,
          onChange: (e) => {
            const value = e.target.value.replace(/\D/g, "");
            if (value.length <= 10) setPrimaryphone(value);
          },
          maxLength: 10,
          placeholder: "Enter Primary Phone",
        })}

        {renderInput({
          label: "Email",
          name: "email",
          value: email,
          onChange: (e) => setEmail(e.target.value),
          type: "email",
          placeholder: "Enter Email",
        })}

        {renderInput({
          label: "Address Line",
          name: "addressline",
          value: addressline,
          onChange: (e) => setAddressline(e.target.value),
          placeholder: "Enter Address",
        })}

        {renderInput({
          label: "Pincode",
          name: "pincode",
          value: pincode,
          onChange: (e) => {
            const value = e.target.value;
            setPincode(value);
            if (value.length === 6) {
              fetchPincodeDetails(value);
            }
          },
          type: "text",
          maxLength: 6,
          required: true,
          error: errors.pincode,
          placeholder: "Enter Pincode",
        })}

        {renderInput({
          label: "City",
          name: "city",
          value: city,
          readOnly: true,
          disabled: true,
          placeholder: "City",
        })}

        {renderInput({
          label: "District",
          name: "dist",
          value: dist,
          readOnly: true,
          disabled: true,
          placeholder: "District",
        })}

        {renderInput({
          label: "State",
          name: "state",
          value: state,
          readOnly: true,
          disabled: true,
          placeholder: "State",
        })}

        {renderInput({
          label: "Country",
          name: "country",
          value: country,
          readOnly: true,
          disabled: true,
          placeholder: "Country",
        })}

        {renderInput({
          label: "Latitude",
          name: "latd",
          value: latd,
          onChange: (e) => setLatd(e.target.value),
          placeholder: "Enter Latitude",
        })}

        {renderInput({
          label: "Longitude",
          name: "longt",
          value: longt,
          onChange: (e) => setLongt(e.target.value),
          placeholder: "Enter Longitude",
        })}
      </Box>
    </Box>
  );

  const renderFactoryRegistrationTab = () => (
    <Box
      sx={{
        pt: 1.5,
        "& .form-group": {
          marginBottom: 0,
        },
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: "repeat(3, minmax(0, 1fr))",
          },
          columnGap: { xs: 1.5, md: 2 },
          rowGap: 1.5,
        }}
      >
        {renderInput({
          label: "Factory Registration Date",
          name: "factoryRegDate",
          value: formData.factoryRegDate,
          onChange: handleInputChange,
          type: "date",
          placeholder: "Select Date",
        })}

        {renderInput({
          label: "NIC Code of the Factory",
          name: "nicCode",
          value: formData.nicCode,
          onChange: handleInputChange,
          placeholder: "Enter NIC Code",
        })}

        {renderInput({
          label: "Nature of Manufacturing",
          name: "natureOfManufacturing",
          value: formData.natureOfManufacturing,
          onChange: handleInputChange,
          required: true,
          error: errors.natureOfManufacturing,
          placeholder: "Enter Nature of Manufacturing",
        })}

        {renderInput({
          label: "Horse Power (HP)",
          name: "horsePower",
          value: formData.horsePower,
          onChange: handleInputChange,
          type: "number",
          min: 0,
          required: true,
          error: errors.horsePower,
          placeholder: "Enter HP",
        })}

        {renderInput({
          label: "Kilowatt (KW)",
          name: "kilowatt",
          value: formData.kilowatt,
          onChange: handleInputChange,
          type: "number",
          min: 0,
          required: true,
          error: errors.kilowatt,
          placeholder: "Enter KW",
        })}

        {renderInput({
          label: "Fees",
          name: "fees",
          value: formData.fees,
          onChange: handleInputChange,
          required: true,
          error: errors.fees,
          placeholder: "Enter Fees",
        })}

        {renderSelect({
          label: "Factory License Renewal Status",
          options: licenseRenewalData,
          value: formData.licenseRenewalStatus,
          onChange: (selected) =>
            handleInputChange({
              target: {
                name: "licenseRenewalStatus",
                value: selected?.value || "",
              },
            }),
          placeholder: "Select Status",
          required: true,
          error: errors.licenseRenewalStatus,
        })}

        {renderInput({
          label: "Factory License Strength",
          name: "licenseStrength",
          value: formData.licenseStrength,
          onChange: handleInputChange,
          type: "number",
          min: 0,
          required: true,
          error: errors.licenseStrength,
          placeholder: "Enter Strength",
        })}

        {renderSelect({
          label: "Factory Hazard Category",
          options: hazardCategoryData,
          value: formData.hazardCategory,
          onChange: (selected) =>
            handleInputChange({
              target: {
                name: "hazardCategory",
                value: selected?.value || "",
              },
            }),
          placeholder: "Select Category",
          required: true,
          error: errors.hazardCategory,
        })}

        {renderSelect({
          label: "Covered Under Section",
          options: sectionData,
          value: formData.coveredUnderSection,
          onChange: (selected) =>
            handleInputChange({
              target: {
                name: "coveredUnderSection",
                value: selected?.value || "",
              },
            }),
          placeholder: "Select Section",
          required: true,
          error: errors.coveredUnderSection,
        })}

        {renderSelect({
          label: "Sector",
          options: sectorData,
          value: formData.sector,
          onChange: (selected) =>
            handleInputChange({
              target: {
                name: "sector",
                value: selected?.value || "",
              },
            }),
          placeholder: "Select Sector",
          required: true,
          error: errors.sector,
        })}

        {renderSelect({
          label: "Factory Working Status",
          options: workingData,
          value: formData.workingStatus,
          onChange: (selected) =>
            handleInputChange({
              target: {
                name: "workingStatus",
                value: selected?.value || "",
              },
            }),
          placeholder: "Select Working Status",
          required: true,
          error: errors.workingStatus,
        })}

        {renderSelect({
          label: "Ownership",
          options: ownshirpData,
          value: formData.ownership,
          onChange: (selected) =>
            handleInputChange({
              target: {
                name: "ownership",
                value: selected?.value || "",
              },
            }),
          placeholder: "Select Ownership",
          required: true,
          error: errors.ownership,
        })}

        {renderInput({
          label: "Occupier Name",
          name: "occupiername",
          value: formData.occupiername,
          onChange: handleInputChange,
          placeholder: "Enter Occupier Name",
        })}

        {renderInput({
          label: "Occupier Email",
          name: "occupierEmail",
          value: formData.occupierEmail,
          onChange: handleInputChange,
          type: "email",
          placeholder: "Enter Occupier Email",
        })}

        {renderInput({
          label: "Occupier Phone",
          name: "occupierPhone",
          value: formData.occupierPhone,
          onChange: (e) => {
            const value = e.target.value.replace(/\D/g, "");
            if (value.length <= 10) {
              handleInputChange({
                target: {
                  name: "occupierPhone",
                  value,
                },
              });
            }
          },
          maxLength: 10,
          placeholder: "Enter Occupier Phone",
        })}

        {renderInput({
          label: "Occupier Address",
          name: "occupierAddress",
          value: formData.occupierAddress,
          onChange: handleInputChange,
          placeholder: "Enter Occupier Address",
        })}

        {renderInput({
          label: "Manager Name",
          name: "managername",
          value: formData.managername,
          onChange: handleInputChange,
          placeholder: "Enter Manager Name",
        })}

        {renderInput({
          label: "Manager Email",
          name: "managerEmail",
          value: formData.managerEmail,
          onChange: handleInputChange,
          type: "email",
          placeholder: "Enter Manager Email",
        })}

        {renderInput({
          label: "Manager Phone",
          name: "managerPhone",
          value: formData.managerPhone,
          onChange: (e) => {
            const value = e.target.value.replace(/\D/g, "");
            if (value.length <= 10) {
              handleInputChange({
                target: {
                  name: "managerPhone",
                  value,
                },
              });
            }
          },
          maxLength: 10,
          placeholder: "Enter Manager Phone",
        })}

        {renderInput({
          label: "Manager Address",
          name: "managerAddress",
          value: formData.managerAddress,
          onChange: handleInputChange,
          placeholder: "Enter Manager Address",
        })}
      </Box>
    </Box>
  );

  const renderDirectorTab = () => (
    <Box sx={{ pt: 1.5 }}>
      {directorData.map((director, index) => (
        <Box
          key={director.id ?? index}
          sx={{
            border: "1px solid #DCE4EC",
            borderRadius: "10px",
            p: { xs: 1.25, sm: 1.5 },
            mb: 1.5,
            backgroundColor: "#FBFCFD",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1.25,
            }}
          >
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 700,
                color: "#123B5D",
              }}
            >
              Director {index + 1}
            </Typography>

            {directorData.length > 1 && (
              <Button
                type="button"
                variant="outlined"
                color="error"
                size="small"
                onClick={() => removeDirector(index)}
                sx={{
                  minWidth: 82,
                  height: 32,
                  borderRadius: "7px",
                  textTransform: "none",
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                Remove
              </Button>
            )}
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "repeat(2, minmax(0, 1fr))",
              },
              columnGap: 2,
              rowGap: 1.5,
            }}
          >
            {renderInput({
              label: "First Name",
              value: director.firstName,
              onChange: (e) =>
                handleDirectorChange(index, "firstName", e.target.value),
              required: true,
              placeholder: "Enter First Name",
            })}

            {renderInput({
              label: "Last Name",
              value: director.lastName,
              onChange: (e) =>
                handleDirectorChange(index, "lastName", e.target.value),
              required: true,
              placeholder: "Enter Last Name",
            })}

            {renderInput({
              label: "Contact Number",
              value: director.contactNumber,
              onChange: (e) => {
                const value = e.target.value.replace(/\D/g, "");
                if (value.length <= 10) {
                  handleDirectorChange(index, "contactNumber", value);
                }
              },
              required: true,
              maxLength: 10,
              placeholder: "Enter Contact Number",
            })}

            {renderInput({
              label: "Email Address",
              value: director.email,
              onChange: (e) =>
                handleDirectorChange(index, "email", e.target.value),
              type: "email",
              required: true,
              placeholder: "Enter Email Address",
            })}
          </Box>
        </Box>
      ))}

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button
          type="button"
          variant="outlined"
          onClick={addDirector}
          sx={{
            height: 34,
            borderRadius: "7px",
            textTransform: "none",
            fontSize: 12.5,
            fontWeight: 600,
            color: "#123B5D",
            borderColor: "#B9C8D6",
            "&:hover": {
              borderColor: "#123B5D",
              backgroundColor: "#F4F8FB",
            },
          }}
        >
          + Add Director
        </Button>
      </Box>
    </Box>
  );

  const renderEmployeeTab = () => (
    <Box sx={{ pt: 1.5 }}>
      {employeeData.map((employee, index) => (
        <Box
          key={employee.id ?? index}
          sx={{
            border: "1px solid #DCE4EC",
            borderRadius: "10px",
            p: { xs: 1.25, sm: 1.5 },
            mb: 1.5,
            backgroundColor: "#FBFCFD",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1.25,
            }}
          >
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 700,
                color: "#123B5D",
              }}
            >
              Employee Group {index + 1}
            </Typography>

            {employeeData.length > 1 && (
              <Button
                type="button"
                variant="outlined"
                color="error"
                size="small"
                onClick={() => removeEmployee(index)}
                sx={{
                  minWidth: 82,
                  height: 32,
                  borderRadius: "7px",
                  textTransform: "none",
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                Remove
              </Button>
            )}
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "repeat(3, minmax(0, 1fr))",
              },
              columnGap: 2,
              rowGap: 1.5,
            }}
          >
            {renderSelect({
              label: "Employee Type",
              options: employeeTypeOptions,
              value: employee.employeeType,
              onChange: (selected) =>
                handleEmployeeChange(
                  index,
                  "employeeType",
                  selected?.value || "",
                ),
              placeholder: "Select Employee Type",
            })}

            {renderInput({
              label: "Adult Male Count",
              value: employee.adultMale,
              onChange: (e) =>
                handleEmployeeChange(index, "adultMale", e.target.value),
              type: "number",
              min: 0,
              placeholder: "Enter Count",
            })}

            {renderInput({
              label: "Adult Female Count",
              value: employee.adultFemale,
              onChange: (e) =>
                handleEmployeeChange(index, "adultFemale", e.target.value),
              type: "number",
              min: 0,
              placeholder: "Enter Count",
            })}
          </Box>
        </Box>
      ))}

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button
          type="button"
          variant="outlined"
          onClick={addEmployee}
          sx={{
            height: 34,
            borderRadius: "7px",
            textTransform: "none",
            fontSize: 12.5,
            fontWeight: 600,
            color: "#123B5D",
            borderColor: "#B9C8D6",
            "&:hover": {
              borderColor: "#123B5D",
              backgroundColor: "#F4F8FB",
            },
          }}
        >
          + Add Employee
        </Button>
      </Box>
    </Box>
  );

  const renderDocumentsTab = () => (
    <Box sx={{ pt: 1.5 }}>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          border: "1px solid #DCE4EC",
          borderRadius: "10px",
          overflow: "auto",
          boxShadow: "none",
        }}
      >
        <Table sx={{ minWidth: 900 }}>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "#123B5D",
              }}
            >
              <TableCell
                sx={{
                  color: "#FFFFFF",
                  fontWeight: 700,
                  fontSize: 12.5,
                  py: 1.25,
                }}
              >
                Upload File
              </TableCell>
              <TableCell
                sx={{
                  color: "#FFFFFF",
                  fontWeight: 700,
                  fontSize: 12.5,
                  py: 1.25,
                }}
              >
                File Name
              </TableCell>
              <TableCell
                sx={{
                  color: "#FFFFFF",
                  fontWeight: 700,
                  fontSize: 12.5,
                  py: 1.25,
                }}
              >
                File Purpose
              </TableCell>
              <TableCell
                sx={{
                  color: "#FFFFFF",
                  fontWeight: 700,
                  fontSize: 12.5,
                  py: 1.25,
                }}
              >
                Preview
              </TableCell>
              <TableCell
                sx={{
                  color: "#FFFFFF",
                  fontWeight: 700,
                  fontSize: 12.5,
                  py: 1.25,
                  width: 170,
                }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {documents.map((doc, index) => (
              <TableRow
                key={index}
                hover
                sx={{
                  "& td": {
                    borderColor: "#E8EDF2",
                    verticalAlign: "middle",
                  },
                }}
              >
                <TableCell sx={{ minWidth: 230 }}>
                  <input
                    type="file"
                    accept="*/*"
                    ref={(el) => (fileInputRefs.current[index] = el)}
                    onChange={(e) => handleFileUpload(index, e)}
                    className="form-control"
                  />
                </TableCell>

                <TableCell sx={{ minWidth: 180 }}>
                  <input
                    type="text"
                    className="form-control"
                    value={doc.fileName}
                    readOnly
                    placeholder="File name"
                  />
                </TableCell>

                <TableCell sx={{ minWidth: 220 }}>
                  <textarea
                    className="form-control"
                    rows={2}
                    placeholder="Enter file purpose"
                    value={doc.filePurpose}
                    onChange={(e) => handlePurposeChange(index, e.target.value)}
                  />
                </TableCell>

                <TableCell
                  sx={{
                    minWidth: 140,
                    textAlign: "center",
                  }}
                >
                  {doc.previewUrl ? (
                    doc.fileType.includes("pdf") ? (
                      <a
                        href={doc.previewUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#2676C9",
                          fontWeight: 600,
                          fontSize: 12.5,
                          textDecoration: "none",
                        }}
                      >
                        View PDF
                      </a>
                    ) : (
                      <Box
                        component="img"
                        src={doc.previewUrl}
                        alt="preview"
                        sx={{
                          width: 88,
                          height: 68,
                          objectFit: "cover",
                          borderRadius: "6px",
                          border: "1px solid #DCE4EC",
                        }}
                      />
                    )
                  ) : (
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#8A97A4",
                      }}
                    >
                      No Preview
                    </Typography>
                  )}
                </TableCell>

                <TableCell>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.75,
                      justifyContent: "center",
                    }}
                  >
                    {documents.length > 1 && (
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        startIcon={<DeleteOutlineIcon />}
                        onClick={() => removeDocumentRow(index)}
                        sx={{
                          height: 32,
                          borderRadius: "7px",
                          textTransform: "none",
                          fontSize: 11.5,
                          fontWeight: 600,
                        }}
                      >
                        Delete
                      </Button>
                    )}

                    {index === documents.length - 1 && (
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={addDocumentRow}
                        sx={{
                          height: 32,
                          borderRadius: "7px",
                          textTransform: "none",
                          fontSize: 11.5,
                          fontWeight: 600,
                          color: "#123B5D",
                          borderColor: "#B9C8D6",
                          "&:hover": {
                            borderColor: "#123B5D",
                            backgroundColor: "#F4F8FB",
                          },
                        }}
                      >
                        Add
                      </Button>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );

  const tabLabels =
    mode === "A"
      ? [
          "Register New Factory",
          "Factory Registration Details",
          "Company Director Details",
          "Add Employee Details",
          "Upload Documents",
        ]
      : [
          "Basic Details",
          "Factory Registration Details",
          "Company Director Details",
          "Add Employee Details",
          "Upload Documents",
        ];

  return (
    <>
      <SucessModal
        show={ShowSucessModal}
        onClose={handleCloseSucessModal}
        headerText={titile}
        message={SucessMessage}
      />

      <Box className="popupmodal-maindiv">
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={tabSx}
        >
          {tabLabels.map((label, index) => (
            <Tab key={index} label={label} />
          ))}
        </Tabs>

        {activeTab === 0 && renderBasicTab()}
        {activeTab === 1 && renderFactoryRegistrationTab()}
        {activeTab === 2 && renderDirectorTab()}
        {activeTab === 3 && renderEmployeeTab()}
        {activeTab === 4 && renderDocumentsTab()}

        <div className="bottombtn">
          <button
            className="btn btn-success"
            disabled={loading}
            onClick={handlesubmit}
          >
            Save
          </button>
          <button className="btn btn-danger" onClick={clearFields}>
            Reset
          </button>
        </div>
      </Box>

      {loading && <CustomLoader />}
    </>
  );
};

export default Auditee;
